import React from "react";
const ServiceScreen = () => {
  return <div>Welcome to Service Screen</div>;
};

export default ServiceScreen;
